import React, { useState } from 'react';
import { Tab } from 'common/components';
import { useAuth } from 'contexts/AuthContext';
import { UserRole } from 'types/userRoles';
import { AgentMonitoringTab, WorkflowAssignmentsTab } from './components';
import styles from './ManagerCommandCenter.module.scss';

type ActiveTab = 'monitoring' | 'assignments';

const ManagerCommandCenter: React.FC = () => {
    const { userRoles } = useAuth();

    const isManager = userRoles.some(
        (role) => role === UserRole.MANAGER || role === UserRole.SUPER_ADMIN || role === UserRole.ADMIN
    );

    const [activeTab, setActiveTab] = useState<ActiveTab>('monitoring');

    const tabs = [
        { id: 'monitoring', label: 'Agent Monitoring' },
        ...(isManager ? [{ id: 'assignments', label: 'Workflow Assignments' }] : []),
    ];

    return (
        <div className={styles.container}>
            <div className={styles.header}>
                <h1>Manager Command Center</h1>
            </div>

            <Tab tabs={tabs} activeTab={activeTab} onTabChange={(id) => setActiveTab(id as ActiveTab)} />

            <div className={styles.contentArea}>
                {activeTab === 'monitoring' && <AgentMonitoringTab isManager={isManager} />}
                {activeTab === 'assignments' && isManager && <WorkflowAssignmentsTab />}
            </div>
        </div>
    );
};

export default ManagerCommandCenter;
